export default {
  ONBOARDING_STEP_KEY: 'onboarding_current_step', // @deprecated удаляется без миграции
  ONBOARDING_PROGRESS: 'onboarding_progress', // @deprecated глобальный ключ, удаляется без миграции
  ONBOARDING_PROGRESS_PREFIX: 'onboarding_progress',
  ONBOARDING_DATA_PREFIX: 'onboarding_data'
}
